import React, { Fragment, createContext, useReducer, useState, useEffect } from "react";
import Layout from "../layout";
import SEO from "../../SEO";
// import Slider from "./Slider";
import ProductCategory from "./ProductCategory";
import { homeState, homeReducer } from "./HomeContext";
import InfiniteProductScroll from "./InfiniteProductScroll";
import Testimonials from './Testimonials';
import Nouveautes from './Nouveautes';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export const HomeContext = createContext();


const HomeComponent = () => {
  const phrases = [
    "Découvrez l'élégance dans chaque goutte.",
    "Un parfum, une signature unique."
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % phrases.length);
    }, 5000); // change toutes les 5s
    return () => clearInterval(interval);
  }, [phrases.length]);

  // Animations au scroll
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
          entry.target.style.opacity = '1';
        }
      });
    }, observerOptions);

    const sections = document.querySelectorAll('.reveal-on-scroll');
    sections.forEach(section => {
      observer.observe(section);
    });

    return () => {
      sections.forEach(section => {
        observer.unobserve(section);
      });
    };
  }, []);

  return (
    <Fragment>
      <SEO 
        title="JamaalStore - Parfums Authentiques, Musc & Huiles Essentielles au Sénégal | Livraison Dakar"
        description="Découvrez notre collection exclusive de parfums authentiques, musc, huiles essentielles et fragrances orientales. Livraison rapide à Dakar et partout au Sénégal. Qualité garantie."
        keywords="parfum Sénégal, parfum Dakar, musc Sénégal, huile essentielle, parfum oriental, parfum arabe, oud, bakhour, parfum authentique, boutique parfum Dakar, parfum luxe, fragrance, eau de parfum, musc blanc, JamaalStore, livraison Dakar"
        url="https://jamaalstore.com"
      />

      {/* Hero Section Amélioré */}
      <section 
  className="relative flex items-center justify-center bg-cover bg-center bg-no-repeat h-[500px] sm:h-[550px] md:h-[600px] lg:h-[650px] xl:h-[700px] overflow-hidden"
  style={{ 
    backgroundImage: "url('/images/parfum1.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center center'
  }}
>
  {/* Overlay gradient pour meilleur contraste */}
  <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-blue-900/40"></div>

  {/* Particules flottantes décoratives */}
  {[...Array(15)].map((_, i) => (
    <div
      key={i}
      className="absolute z-5 rounded-full bg-white/20 animate-float-slow"
      style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${8 + Math.random() * 4}s`,
        width: `${Math.random() * 6 + 3}px`,
        height: `${Math.random() * 6 + 3}px`,
      }}
    />
  ))}

  {/* Contenu principal du hero */}
  <div className="relative z-10 max-w-5xl mx-auto px-6 py-12 text-center space-y-6 md:space-y-8">
    {/* Badge de bienvenue - Animation */}
    <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-yellow-600 text-gray-900 rounded-full text-sm md:text-base font-bold shadow-2xl backdrop-blur-sm animate-fade-in-down">
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
      Nouvelle Collection
    </div>

    {/* Titre principal animé */}
    <h1 className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight drop-shadow-2xl animate-fade-in-up animation-delay-200">
      <span key={index} className="inline-block animate-fade-slide-enhanced">
        {phrases[index]}
      </span>
    </h1>

    {/* Sous-titre descriptif - Animation */}
    <p className="text-gray-200 text-lg sm:text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed font-medium drop-shadow-lg animate-fade-in-up animation-delay-400">
      Découvrez notre collection exclusive de parfums authentiques.
    </p>

    {/* Call to Action - Animation */}
    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4 animate-fade-in-up animation-delay-600">
      <a
        href="#shop"
        className="group relative inline-flex items-center gap-2 px-8 py-4 bg-yellow-600 hover:bg-yellow-500 text-gray-900 font-bold text-lg rounded-full shadow-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-yellow-400/50"
      >
        <span>Découvrir nos produits</span>
        <svg 
          className="w-5 h-5 group-hover:translate-x-1 transition-transform" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
        </svg>
      </a>
    </div>

    {/* Indicateur de scroll - Animation */}
    <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce-gentle animation-delay-800">
      <svg className="w-6 h-6 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
      </svg>
    </div>
  </div>

<span id="shop" className="absolute bottom-0"></span>
 
</section>

    
 

      {/* Category, Search & Filter Section - Amélioration Design */}
      <section id="categories" className="bg-gradient-to-b from-gray-50 to-white py-4 md:py-6 reveal-on-scroll opacity-0">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <ProductCategory />
        </div>
      </section>

      
      {/* Product Section */}
      <section className="bg-white py-4 md:py-6 pb-2 reveal-on-scroll opacity-0">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <InfiniteProductScroll />
        </div>
      </section>
      
      {/* Testimonials section */}
      <div id="testimonials" className="reveal-on-scroll opacity-0 -mt-2">
        <Testimonials />
      </div>

    
    </Fragment>
  );
};

// Animation keyframes Tailwind
const styles = `
@keyframes fadeSlide {
  0% { opacity: 0; transform: translateY(-40px); }
  20% { opacity: 1; transform: translateY(0); }
  80% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-40px); }
}

@keyframes fadeSlideEnhanced {
  0% { opacity: 0; transform: translateY(-30px) scale(0.95); }
  15% { opacity: 1; transform: translateY(0) scale(1); }
  85% { opacity: 1; transform: translateY(0) scale(1); }
  100% { opacity: 0; transform: translateY(-30px) scale(0.95); }
}

@keyframes floatSlow {
  0%, 100% { 
    transform: translateY(0) translateX(0); 
    opacity: 0.3;
  }
  50% { 
    transform: translateY(-30px) translateX(10px); 
    opacity: 0.6;
  }
}

@keyframes bounceGentle {
  0%, 100% { 
    transform: translateY(0);
  }
  50% { 
    transform: translateY(-10px);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(-40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-fade-slide {
  animation: fadeSlide 5s ease-in-out forwards;
}

.animate-fade-slide-enhanced {
  animation: fadeSlideEnhanced 5s ease-in-out forwards;
}

.animate-float-slow {
  animation: floatSlow linear infinite;
}

.animate-bounce-gentle {
  animation: bounceGentle 2s ease-in-out infinite;
}

.animate-fade-in-up {
  animation: fadeInUp 0.8s ease-out forwards;
}

.animate-fade-in-down {
  animation: fadeInDown 0.8s ease-out forwards;
}

.animate-slide-in-right {
  animation: slideInRight 0.8s ease-out forwards;
}

.animation-delay-200 {
  animation-delay: 0.2s;
  opacity: 0;
}

.animation-delay-400 {
  animation-delay: 0.4s;
  opacity: 0;
}

.animation-delay-600 {
  animation-delay: 0.6s;
  opacity: 0;
}

.animation-delay-800 {
  animation-delay: 0.8s;
  opacity: 0;
}

.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.snap-x {
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
}

.snap-center {
  scroll-snap-align: center;
}
`;


const Home = (props) => {
  const [data, dispatch] = useReducer(homeReducer, homeState);
  return (
    <Fragment>
      
      <style>{styles}</style>
      <HomeContext.Provider value={{ data, dispatch }}>
        <Layout children={<HomeComponent />} />
      </HomeContext.Provider>
      
    </Fragment>
    
  );
};

export default Home;
